import {BasePageLayout} from "../components/grouping/BasePageLayout";
import {useParams} from "react-router-dom";
import {useAlbum} from "../api/albumapi";
import {Button, Col, Row} from "react-bootstrap";
import {minioBaseUrl} from "../data/defaultConfig";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import {ModalPopUp} from "../components/grouping/ModalPopUp";
import {BasePopup} from "../components/grouping/BasePopup";
import {ModalContentContainer} from "../components/grouping/ModalContentContainer";
import {useState} from "react";

var Carousel = require('react-responsive-carousel').Carousel;

export function AlbumViewPage(props) {
    const [open, setOpen] = useState();
    const [selectedIndex, setSelectedIndex] = useState(0);
    const {id} = useParams();
    const {album} = useAlbum(id);
    const albumCopy = album ? {...album} : {};
    if (albumCopy?.reverseSorting === false){
        albumCopy?.filealbums?.sort(function (a, b) {
            if(a.fileName){
                if (a.fileName < b.fileName) {
                    return 1;
                }
                if (a.fileName > b.fileName) {
                    return -1;
                }
            }else{
                if (a.url < b.url) {
                    return 1;
                }
                if (a.url > b.url) {
                    return -1;
                }
            }
            return 0;
        });
    }else {
        albumCopy?.filealbums?.sort(function (a, b) {
            if(a.fileName){
                if (b.fileName < a.fileName) {
                    return 1;
                }
                if (b.fileName > a.fileName) {
                    return -1;
                }
            }else{
                if (b.url < a.url) {
                    return 1;
                }
                if (b.url > a.url) {
                    return -1;
                }
            }
            return 0;
        });
    }



    return <BasePageLayout title={`${album?.title}`}>
        {albumCopy?.filealbums?.map((fa, index) => <AlbumImageItem onOpenChange={setOpen} index={index}
                                                       onSelectedIndexChange={setSelectedIndex}
                                                       open={open} key={fa.id} album={fa}/>)}
        <ModalPopUp open={open} onOpenChanged={setOpen}
                    modalContent={<ModalContentContainer style={{backgroundColor: 'grey'}} onOpenChanged={setOpen}>

                        <AlbumCarousel selectedIndex={selectedIndex}
                                       album={album}/>

                    </ModalContentContainer>}/>
    </BasePageLayout>
}


function AlbumImageItem(props) {
    const {album, onOpenChange, open, onSelectedIndexChange, index} = props;
    return <Col xs={12} lg={3} className={'p-2'}>
        <Button onClick={() => {
            onSelectedIndexChange(index);
            onOpenChange(!open);
        }} className={'btn-light w-100 p-0 m-0 bg-transparent text-black'}>
            <Row className={'g-0 border border-2 border-black rounded-2'} style={{
                width: '100%',
                height: '300px',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundImage: `url(${minioBaseUrl + album?.url})`
            }}>


            </Row>
        </Button>
    </Col>
}

function AlbumCarousel(props) {
    const {album, selectedIndex} = props;
    return <div style={{maxHeight: "95vh"}}>
        <Carousel selectedItem={selectedIndex} centerMode={false} showIndicators={false} showThumbs={false}
                  showStatus={false}
                  dynamicHeight={true}
                  useKeyboardArrows={true} showArrows={true}>
            {album?.filealbums.map(a =>
                <Row className={'g-0 justify-content-center'}>
                    <img style={{width: '70%'}} src={minioBaseUrl + a?.url} alt={"img"}/>
                </Row>
            )}
        </Carousel>
    </div>


}